import { guardString } from "@msuite/utils/strings";
import type { Nullable } from "@msuite/utils/types";
import type { IconName } from "../icons";

const GAEB_EXTENSION_RE = /\.(x83|x84|d83|d84|p83|p84|p85|p86)$/i;

export function getFileIconName(
	contentType: Nullable<string>,
	fileName?: Nullable<string>,
): IconName {
	if (!contentType && !fileName) return "Loader";
	if (contentType === "application/x-gaeb") return "FileSliders";
	if (fileName && GAEB_EXTENSION_RE.test(fileName)) return "FileSliders";

	const imageTypes = [
		"image/jpeg",
		"image/png",
		"image/gif",
		"image/svg+xml",
		"image/webp",
		"image/tiff",
		"image/bmp",
		"image/x-icon",
	];

	const videoTypes = ["video/quicktime", "video/mp4", "video/webm", "video/ogg"];

	const audioTypes = ["audio/mpeg", "audio/wav", "audio/ogg", "audio/aac"];

	switch (contentType) {
		case "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet":
			return "FileSpreadsheet";
		case "application/vnd.ms-excel":
			return "FileChartPie";
		case "application/pdf":
			return "FileText";
		case "text/markdown":
			return "FileText";
		case "text/plain":
			return "FileText";
		case "application/json":
			return "FileCode";
		default:
			if (imageTypes.includes(guardString(contentType))) return "FileImage";
			if (videoTypes.includes(guardString(contentType))) return "FileVideo";
			if (audioTypes.includes(guardString(contentType))) return "FileAudio";
			return "File";
	}
}
